import { ActionReducerMap } from '@ngrx/store';
import { State } from 'src/app/lobby/lobby-central-views/state/index';
import * as centralLocationReducer from './lobby-central-location-view.reducer';
import * as centralStaffReducer from './lobby-central-staff-view.reducer';
import * as centralLobbyReducer from './lobby-central-lobby.reducer';
import * as CentralLocationSelectorReducer from './lobby-central-views-location-selector.reducer';

export const reducers: ActionReducerMap<State> = {
    lobbyCentralStaffView: centralStaffReducer.lobbyCentralStaffViewReducer,
    lobbyCentralLocationView: centralLocationReducer.lobbyCentralLocationViewReducer,
    lobbyCentralLocationSelector: CentralLocationSelectorReducer.lobbyCentralLocationSelectorReducer,
    lobbyCentralView: centralLobbyReducer.lobbyCentralLobbyViewReducer
};
